export const triggerDownload = (href: string, filename: string): void => {
  const link = document.createElement('a');
  link.href = href;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
};

/** Revoked on the next tick: Safari cancels the download if the URL dies during the click. */
export const downloadTextFile = (text: string, filename: string, mediaType: string): void => {
  const href = URL.createObjectURL(new Blob([text], { type: mediaType }));
  triggerDownload(href, filename);
  setTimeout(() => URL.revokeObjectURL(href), 0);
};

/** Empty when nothing survives — callers supply their own fallback. */
export const slugify = (value: string): string =>
  value
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

/** Local time, not UTC: the stamp is read by whoever asked for the file. */
export const fileTimestamp = (date: Date): string => {
  const pad = (value: number) => String(value).padStart(2, '0');
  return `${date.getFullYear()}${pad(date.getMonth() + 1)}${pad(date.getDate())}-${pad(date.getHours())}${pad(date.getMinutes())}`;
};
